import script from "./HomeViewRu.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewRu.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewRu.vue?vue&type=style&index=0&id=0a3cc5fa&lang=css"

const __exports__ = script;

export default __exports__